import protoRoot from "../proto-root";
import CameraAndFlashlightState from "../private/CameraAndFlashlightState";

const name = "startVideoBroadcastingResponse";

function create({ result, cameraId }) {
  const StartVideoBroadcasting = protoRoot.lookupType(
    "comm.StartVideoBroadcastingRPCResponse"
  );
  const Result = StartVideoBroadcasting.lookupEnum("Result");

  const response = StartVideoBroadcasting.create({
    result: Result.values[result],
    cameraAndFlashlightState: CameraAndFlashlightState.create({ cameraId })
  });
  return { payload: response, name, sendBy: "xmpp" };
}

export default {
  create,
  name
};

// message StartVideoBroadcastingRPCResponse {
//     enum Result {
//         SUCCESS = 0;
//         NOT_AVAILABLE = 1;
//     }
//     Result result = 1;
//     VideoFlashlightState flashlightState = 2;
// }
